export default __webpack_public_path__ + "static/media/flower-4865379.db2a5120.png";